export default {
  install(Vue) {
    // make sure we are nuxt friendly
    if (typeof window !== 'undefined') {
      const VPopover = require('vue-js-popover'); // eslint-disable-line global-require

      Vue.use(VPopover.default);
      const subscription = new Vue();
      const ASPopover = Vue.options.components.Popover.extend({
        props: {
          hideDelay: {
            type: Number,
            default: 0,
          },
          ignoreTopAlignment: { // Added for carousel cards, `overflow: hidden` causing issues
            type: Boolean,
          },
        },
        methods: {
          getDropdownPosition(event) {
            const { target, position } = event;

            const directions = {
              left: [-1, 0],
              right: [1, 0],
              top: [0, 1],
              bottom: [0, -1],
            };

            const direction = directions[position];
            const { dropdown } = this.$refs;

            const trRect = target.getBoundingClientRect();
            const ddRect = dropdown.getBoundingClientRect();

            const { offsetLeft } = target;
            const { offsetTop } = target;

            const shiftY = 0.5 * (ddRect.height + trRect.height);

            const centerX = offsetLeft - 0.5 * (ddRect.width - trRect.width);
            const centerY = offsetTop + trRect.height - shiftY;

            let x = direction[0] * 0.5 * (ddRect.width + trRect.width);
            let y = direction[1] * shiftY;

            if (this.pointer) {
              const pointerSize = 6;

              x += direction[0] * pointerSize;
              y += direction[1] * pointerSize;
            }

            // Check if out of bounds right side
            // Use document.body.clientWidth to account for scrollbar
            const PADDING = 4; // So not right against the scrollbar
            let left = Math.round(centerX + x);

            // Check right alignment
            if (document && (document.body.clientWidth < (trRect.right + ddRect.width))) {
              const windowElGap = document.body.clientWidth - trRect.right;
              const relativeMaxRight = Math.floor(offsetLeft + trRect.width + windowElGap);

              left = relativeMaxRight - ddRect.width - PADDING;
            }

            // Check top alignment
            // (+ 12) below -> 6 to compensate for default pointer size, 6 for extra padding
            let top = Math.round(centerY - y);
            if (!this.ignoreTopAlignment && document && position === 'top') {
              // Check if nav is visible -- Hack, hopefully class names don't change
              const navbar = (document.getElementsByClassName('navbar fixed-top') || []);

              if (navbar && navbar[0]) {
                const { y: yNav, height } = navbar[0].getBoundingClientRect() || {};
                const navAdjust = yNav >= 0 ? height : 0;

                if (trRect.top - ddRect.height - navAdjust < 10) {
                  top = top + trRect.height + ddRect.height + 12;
                }
              } else if (trRect.top - ddRect.height < 10) {
                top = top + trRect.height + ddRect.height + 12;
              }
            }

            return {
              left,
              top,
            };
          },
          showEventListener(event) {
            if (this.visible) {
              subscription.$emit(this.hideEventName);
              return;
            }

            const { name, position } = event;
            if (name !== this.name) {
              return;
            }

            this.timeoutEvent = null;

            this.timeout = setTimeout(() => {
              this.positionClass = `dropdown-position-${position}`;
              this.visible = true;

              this.$nextTick(() => {
                this.$emit('show', event);
                this.$nextTick(() => {
                  const newPosition = this.getDropdownPosition(event);
                  this.position = {
                    left: `${newPosition.left}px`,
                    top: `${newPosition.top}px`,
                  };

                  const { dropdown } = this.$refs;

                  if (dropdown) {
                    dropdown.addEventListener('mouseenter', this.removeTimeout);
                    dropdown.addEventListener('mouseleave', this.closeTooltip);
                  }
                });
              });
            }, Math.max(this.delay, 0));
          },
          hideEventListener(event) {
            if (this.timeout) {
              clearTimeout(this.timeout);
            }

            if (this.visible) {
              if (this.hideDelay) {
                this.timeoutEvent = event;

                this.timeout = setTimeout(() => {
                  this.visible = false;
                  this.$emit('hide', event);
                }, this.hideDelay);
              } else {
                this.visible = false;
                this.$emit('hide', event);
              }
            }
          },
          removeTimeout() {
            if (this.timeout) {
              clearTimeout(this.timeout);
            }
          },
          closeTooltip() {
            const { dropdown } = this.$refs;

            if (dropdown) {
              dropdown.removeEventListener('mouseenter', this.removeTimeout);
              dropdown.removeEventListener('mouseleave', this.closeTooltip);
            }

            clearTimeout(this.timeout);
            this.visible = false;
            this.$emit('hide', this.timeoutEvent);
            this.timeoutEvent = null;
          },
        },
        beforeDestroy() {
          this.closeTooltip();
        },
      });
      Vue.component('v-popover', ASPopover);
    }
  },
};
